import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import 'moment/locale/pl'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  },
  differenceIconUp: {
    color: colors.red[900],
  },
  differenceValueUp: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  },
  differenceIconDown: {
    color: colors.green[900],
  },
  differenceValueDown: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  }
}));

const AverageRepairDuration = ({ className, statistics, ...rest }) => {
  const classes = useStyles();
  const seconds = statistics["current"]["average_repair_duration"]
  const average_repair_duration = new Date(seconds * 1000).toISOString().slice(11, 16);
  const diff = statistics["average_repair_duration_diff"];

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              Średni czas naprawy
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {average_repair_duration}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <AccessTimeIcon />
            </Avatar>
          </Grid>
        </Grid>
        {diff > 0 &&
          <Box
            mt={2}
            display="flex"
            alignItems="center"
          >
            <ArrowUpwardIcon className={classes.differenceIconUp}/>
            <Typography
              className={classes.differenceValueUp}
              variant="body2"
            >
              {diff}%
            </Typography>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              Od ostatniego miesiąca
            </Typography>
          </Box>
        }
        {diff < 0 &&
          <Box
            mt={2}
            display="flex"
            alignItems="center"
          >
            <ArrowDownwardIcon className={classes.differenceIconDown}/>
            <Typography
              className={classes.differenceValueDown}
              variant="body2"
            >
              {diff}%
            </Typography>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              Od ostatniego miesiąca
            </Typography>
          </Box>
        }
      </CardContent>
    </Card>
  );
};

AverageRepairDuration.propTypes = {
  className: PropTypes.string
};

export default AverageRepairDuration;
